import React, { useState } from 'react';
import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
} from 'chart.js';
import './dashboard.scss';
import Select from "react-select";
import { TextField, Chip, Autocomplete, MenuItem, InputLabel, Popper, Dialog, DialogTitle, DialogContent, DialogActions, RadioGroup, FormControlLabel, Radio, Stepper, StepLabel, Step, Button } from "@mui/material";
// Register ChartJS components
import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from 'react-router-dom';
import ReactApexChart from 'react-apexcharts';
ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, Filler);

const appointments = [
  {
    name: "Shawn Hampton",
    appointment: "Emergency appointment",
    time: "10:00",
    price: "$30",
    avatar: "../images/avatar/4.jpg",
  },
  {
    name: "Polly Paul",
    appointment: "USG + Consultation",
    time: "10:30",
    price: "$50",
    avatar: "../images/avatar/5.jpg",
  },
  {
    name: "Johen Doe",
    appointment: "Laboratory screening",
    time: "11:00",
    price: "$70",
    avatar: "../images/avatar/6.jpg",
  },
  {
    name: "Harmani Doe",
    appointment: "Keeping pregnant",
    time: "11:30",
    price: "",
    avatar: "../images/avatar/7.jpg",
  },
  {
    name: "Mark Wood",
    appointment: "Primary doctor consultation",
    time: "12:00",
    price: "$30",
    avatar: "../images/avatar/8.jpg",
  },
  {
    name: "Shawn Marsh",
    appointment: "Emergency appointment",
    time: "13:00",
    price: "$90",
    avatar: "../images/avatar/9.jpg",
  },
];

const Dashboard = () => {
  const navigate = useNavigate();
  const [selectedDate, setSelectedDate] = useState("2025-12-30");
  const [showModal1, setShowModal1] = useState(true);
  const [showConfirm, setShowConfirm] = useState(false);
  const [selectedPerson, setSelectedPerson] = useState("");

  const [activeStep, setActiveStep] = useState(0);

  const steps = [
    "Basic Info",
    "Emergency",
    "Health Overview",
    "Medications",
    "Family History",
    "Goals",
    "Final Input",
  ];
  const handleNext = () => setActiveStep((prev) => Math.min(prev + 1, steps.length - 1));
  const handleBack = () => setActiveStep((prev) => Math.max(prev - 1, 0));

  const yesNoOptions = [
    { value: "yes", label: "Yes" },
    { value: "no", label: "No" },
  ];

  const genderOptions = [
    { value: "male", label: "Male" },
    { value: "female", label: "Female" },
    { value: "na", label: "Prefer not to say" },
  ];
  const supplementsOptions = [
    { value: "vitamins", label: "Vitamins" },
    { value: "herbal", label: "Herbal" },
    { value: "ayurvedic", label: "Ayurvedic" },
    { value: "homeopathic", label: "Homeopathic" },
    { value: "protein", label: "Protein supplements" },
    { value: "none", label: "None" },
  ];
  const conditionsOptions = [
    { value: "Hypertension", label: "Hypertension" },
    { value: "diabetes", label: "Diabetes" },
    { value: "heart", label: "Heart disease" },
    { value: "asthma", label: "Asthma" },
    { value: "Thyroid", label: "Thyroid" },
    { value: "PCOS", label: "PCOS" },
    { value: "Autoimmune", label: "Autoimmune" },
    { value: "Kidney", label: "Kidney" },
    { value: "Liver", label: "Liver" },
    { value: "Mental health", label: "Mental health" },
    { value: "Cancer", label: "Cancer" },
    { value: "Other", label: "Other" },
    { value: "None", label: "None" },



  ];
  const allergyOptions = [
    { value: "Nothing", label: "Nothing" },
    { value: "Medication", label: "Medication" },
    { value: "Food", label: "Foode" },
    { value: "Environmental", label: "Environmental" },
    { value: "Other", label: "Other" },
  ];



  const familyOptions = [
    { value: "heart", label: "Heart disease" },
    { value: "stroke", label: "Stroke" },
    { value: "diabetes", label: "Diabetes" },
    { value: "cancer", label: "Cancer" },
    { value: "autoimmune", label: "Autoimmune" },
    { value: "mental", label: "Mental health" },
    { value: "dementia", label: "Dementia" },
    { value: "none", label: "None" },
    { value: "not_sure", label: "Not sure" },
  ];

  const goalsOptions = [
    { value: "medication", label: "Medication safety" },
    { value: "symptoms", label: "Symptoms" },
    { value: "chronic", label: "Chronic care" },
    { value: "prevention", label: "Prevention" },
    { value: "lifestyle", label: "Lifestyle" },
    { value: "lab", label: "Lab understanding" },
  ];

  const selectStyles = {
    control: (base: any) => ({
      ...base,
      minHeight: "38px",
      borderColor: "#ced4da",
      boxShadow: "none",
      menuPortal: (base: any) => ({ ...base, zIndex: 1500, }),
      "&:hover": { borderColor: "#86b7fe" },
    }),
  };

  // List of dates for the paginator
  const dates = [
    { date: "2025-12-22", title: "Monday, 22nd December 2025", label: "Mon<br>22nd" },
    { date: "2025-12-23", title: "Tuesday, 23rd December 2025", label: "Tue<br>23rd" },
    { date: "2025-12-24", title: "Wednesday, 24th December 2025", label: "Wed<br>24th" },
    { date: "2025-12-25", title: "Thursday, 25th December 2025", label: "Thu<br>25th" },
    { date: "2025-12-26", title: "Friday, 26th December 2025", label: "Fri<br>26th" },
    { date: "2025-12-27", title: "Saturday, 27th December 2025", label: "Sat<br>27th", off: true },
    { date: "2025-12-28", title: "Sunday, 28th December 2025", label: "Sun<br>28th", off: true },
    { date: "2025-12-29", title: "Monday, 29th December 2025", label: "Mon<br>29th" },
    { date: "2025-12-30", title: "Tuesday, 30th December 2025", label: "Tuesday<br>December 30th 2025", selected: true },
    { date: "2025-12-31", title: "Wednesday, 31st December 2025", label: "Wed<br>31st" },
    { date: "2026-01-01", title: "Thursday, 1st January 2026", label: "Thu<br>1st" },
    { date: "2026-01-02", title: "Friday, 2nd January 2026", label: "Fri<br>2nd" },
    { date: "2026-01-03", title: "Saturday, 3rd January 2026", label: "Sat<br>3rd", off: true },
    { date: "2026-01-04", title: "Sunday, 4th January 2026", label: "Sun<br>4th", off: true },
    { date: "2026-01-05", title: "Monday, 5th January 2026", label: "Mon<br>5th" },
    { date: "2026-01-06", title: "Tuesday, 6th January 2026", label: "Tue<br>6th" },
    { date: "2026-01-07", title: "Wednesday, 7th January 2026", label: "Wed<br>7th" },
    { date: "2026-01-08", title: "Thursday, 8th January 2026", label: "Thu<br>8th" },
  ];

  const handleDateClick = (date: React.SetStateAction<string>) => {
    setSelectedDate(date);
  };

  // Sample ECG Data
  const ecgData = {
    labels: ['', '', '', '', '', '', '', '', '', '', '', '', '', '', ''],
    datasets: [
      {
        label: 'Heart Rate',
        data: [65, 70, 75, 72, 80, 78, 82, 85, 88, 84, 80, 78, 75, 72, 70],
        borderColor: '#1e88e5',
        backgroundColor: 'rgba(30, 136, 229, 0.1)',
        fill: true,
        tension: 0.4,
        pointRadius: 0,
      },
    ],
  };

  const ecgOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: { legend: { display: false } },
    scales: {
      x: { display: false },
      y: { display: false, min: 50, max: 100 },
    },
  };


  const stepContents = [
    // Step 0 - Basic Info
    <div className="row g-3">
      <div className="col-md-6">
        <label className="form-label">Full Name</label>
        <input type="text" className="form-control" placeholder="Enter full name" />
      </div>

      <div className="col-md-6">
        <label className="form-label">Date of Birth</label>
        <input type="date" className="form-control" />
      </div>

      <div className="col-md-6">
        <label className="form-label">Sex assigned at birth</label>
        <Select
          styles={{
            ...selectStyles,
            menuPortal: (base) => ({
              ...base,
              zIndex: 1500, // higher than MUI Dialog (default ~1300)
            }),
          }}
          options={genderOptions}

          placeholder="Select"
          menuPortalTarget={document.body}
        />
      </div>

      <div className="col-md-6">
        <label className="form-label">Height</label>
        <input type="text" className="form-control" placeholder="cm or ft/in" />
      </div>

      <div className="col-md-6">
        <label className="form-label">Weight</label>
        <input type="text" className="form-control" placeholder="kg or lbs" />
      </div>

      <div className="col-md-6">
        <label className="form-label">Current Location</label>
        <input type="text" className="form-control" placeholder="Country, State/Region" />
      </div>
    </div>,

    // Step 1 - Emergency
    <div className="row g-3">
      <div className="col-md-6">
        <label className="form-label">Emergency Contact Name</label>
        <input type="text" className="form-control" placeholder="Name" />
      </div>

      <div className="col-md-6">
        <label className="form-label">Relationship</label>
        <input type="text" className="form-control" placeholder="Relationship" />
      </div>

      <div className="col-md-6">
        <label className="form-label">Phone Number</label>
        <input type="tel" className="form-control" placeholder="Phone Number" />
      </div>

      <div className="col-md-6">
        <label className="form-label">
          Can we contact this person in case of a serious health concern?
        </label>
        <Select
          styles={{
            ...selectStyles,
            menuPortal: (base) => ({
              ...base,
              zIndex: 1500, // higher than MUI Dialog (default ~1300)
            }),
          }}
          options={[
            { label: "Yes", value: "yes" },
            { label: "No", value: "no" },
          ]}

          placeholder="Select"
          menuPortalTarget={document.body}
        />
      </div>
    </div>,

    // Step 2 - Health Overview
    <div className="row g-3">
      <div className="col-12">
        <label className="form-label">Diagnosed Conditions</label>
        <Select
          styles={{
            ...selectStyles,
            menuPortal: (base) => ({
              ...base,
              zIndex: 1500, // higher than MUI Dialog (default ~1300)
            }),
          }}
          options={conditionsOptions}
          isMulti

          placeholder="Select conditions"
          menuPortalTarget={document.body}
        />
      </div>

      <div className="col-12">
        <label className="form-label">Allergies</label>
        <Select
          styles={{
            ...selectStyles,
            menuPortal: (base) => ({
              ...base,
              zIndex: 1500, // higher than MUI Dialog (default ~1300)
            }),
          }}
          options={allergyOptions}
          isMulti

          placeholder="Select allergies"
          menuPortalTarget={document.body}
        />
      </div>
    </div>,

    // Step 3 - Medications
    <div className="row g-3">
      <div className="col-md-6">
        <label className="form-label">Currently taking medications?</label>
        <Select
          styles={{
            ...selectStyles,
            menuPortal: (base) => ({
              ...base,
              zIndex: 1500, // higher than MUI Dialog (default ~1300)
            }),
          }}
          options={[
            { label: "Yes", value: "yes" },
            { label: "No", value: "no" },
          ]}

          placeholder="Select"
          menuPortalTarget={document.body}
        />
      </div>

      <div className="col-md-6">
        <label className="form-label">Medication Names</label>
        <input
          type="text"
          className="form-control"
          placeholder="Medication name(s)"
        />
      </div>

      <div className="col-12">
        <label className="form-label">
          Supplements / Non-prescription Remedies
        </label>
        <Select
          styles={{
            ...selectStyles,
            menuPortal: (base) => ({
              ...base,
              zIndex: 1500, // higher than MUI Dialog (default ~1300)
            }),
          }}
          options={supplementsOptions}
          isMulti

          placeholder="Select supplements"
          menuPortalTarget={document.body}
        />
      </div>
    </div>,

    // Step 4 - Family History
    <div className="col-12">
      <label className="form-label">
        Family History (Close family conditions)
      </label>
      <Select
        styles={{
          ...selectStyles,
          menuPortal: (base) => ({
            ...base,
            zIndex: 1500, // higher than MUI Dialog (default ~1300)
          }),
        }}
        options={familyOptions}
        isMulti

        placeholder="Select conditions"
        menuPortalTarget={document.body}
      />
    </div>,

    // Step 5 - Goals
    <div className="col-12">
      <label className="form-label">What would you like help with most?</label>
      <Select
        styles={{
          ...selectStyles,
          menuPortal: (base) => ({
            ...base,
            zIndex: 1500, // higher than MUI Dialog (default ~1300)
          }),
        }}
        options={goalsOptions}
        isMulti

        placeholder="Select up to 3"
        menuPortalTarget={document.body}
      />
    </div>,

    // Step 6 - Final Input
    <div className="col-12">
      <label className="form-label">
        Is there anything you'd like us to know about your health right now?
      </label>
      <textarea
        className="form-control"
        rows={4}
        placeholder="Speak, Type, or Upload"
      />
    </div>,
  ];

  const bpData = [130, 125, 135, 140, 145];
  const hrData = [98, 100, 102, 105, 108];
  const glucoseData = [115, 118, 120, 122, 121];
  const oxygenData = [97, 98, 99, 97, 95];

  const commonOptions: any = {
    chart: {
      id: 'basic-line',
      type: 'line',
      toolbar: {
        show: false,   // ✅ This removes the toolbar
      },
    },
    stroke: {
      curve: 'smooth',
      width: 2,
    },
    xaxis: {
      categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May'],  // Example categories for x-axis
    },
    yaxis: {
      show: true,
    },
  };


  return (
    <div className="content-wrapper">
      <div className="container-full">
        <section className="content">
          <div className="row">
            {/* Main Patient Info & Vitals */}
            <div className="col-xxxl-9 col-xl-8 col-12">
              <div className="mb-20 d-flex justify-content-between align-items-center">
                <h1 className="my-md-0 mb-10">Johen Doe</h1>
              </div>

              <div className="row">
                {/* BP Card */}
                <div className="col-xl-3 col-lg-6 col-12">
                  <div className="box bg-primary text-white">
                    <div className="box-body">
                      <div className="mb-15 d-flex justify-content-between align-items-center">
                        <h4 className="my-0">BP</h4>
                        <i className="fs-18 mdi mdi-heart-outline"></i>
                      </div>
                      <h5 className="fw-400 my-0">75/118</h5>
                    </div>
                    <div className="box-body pt-0 " style={{ padding: '5%' }}>
                      <div id="heartrate" style={{ height: '100%' }}>
                        <ReactApexChart
                          type="line"
                          height={200}  // Set height
                          width="100%"  // Set width
                          options={{
                            chart: {
                              id: 'bp-chart',  // Ensure each chart has a unique id
                              height: undefined,
                              zoom: {
                                enabled: true,  // Enable zoom for better exploration
                              },
                              toolbar: {
                                show: false,   // ✅ This removes the toolbar
                              },
                            },

                            stroke: {
                              width: 3,  // Make the line thicker for visibility
                              curve: 'smooth',  // Smooth curve for the line
                              colors: ['#ffffff']
                            },
                            grid: {
                              borderColor: '#444',  // Set grid line color for contrast
                            },
                            tooltip: {
                              theme: 'dark',  // Tooltip theme
                            },
                            xaxis: {
                              categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May'],  // Example X-axis categories
                            },
                            yaxis: {
                              show: true,
                              labels: {
                                style: {
                                  colors: '#fff',  // Set label color to white
                                },
                              },
                            },
                          }}
                          series={[{ name: 'BP', data: bpData }]}  // Make sure bpData is an array of numbers
                        />
                      </div>
                    </div>
                  </div>
                </div>



                {/* Heart Rate Card */}
                <div className="col-xl-3 col-lg-6 col-12">
                  <div className="box text-white box-typography">
                    <div className="box-body">
                      <div className="mb-15 d-flex justify-content-between align-items-center">
                        <h4 className="my-0">Heart Rate</h4>
                        <i className="fs-18 mdi mdi-heart-outline"></i>
                      </div>
                      <h5 className="fw-400 my-0">75/118</h5>
                    </div>
                    <div className="box-body pt-0 " style={{ padding: '5%' }}>
                      <div id="heartrate" style={{ height: '100%' }}>
                        <ReactApexChart
                          type="line"
                          height={200}
                          width="100%"
                          options={{
                            chart: {
                              id: 'bp-chart',  // Ensure each chart has a unique id
                              height: undefined,
                              zoom: {
                                enabled: true,  // Enable zoom for better exploration
                              },
                              toolbar: {
                                show: false,   // ✅ This removes the toolbar
                              },
                            },

                            stroke: {
                              width: 3,  // Make the line thicker for visibility
                              curve: 'smooth',  // Smooth curve for the line
                              colors: ['#5156be']
                            },
                            grid: {
                              borderColor: '#444',  // Set grid line color for contrast
                            },
                            tooltip: {
                              theme: 'dark',  // Tooltip theme
                            },
                            xaxis: {
                              categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May'],  // Example X-axis categories
                            },
                            yaxis: {
                              show: true,
                              labels: {
                                style: {
                                  colors: '#black',  // Set label color to white
                                },
                              },
                            },
                          }}
                          series={[{ name: 'HR', data: hrData }]}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                {/* Glucose Level Card */}
                <div className="col-xl-3 col-lg-6 col-12">
                  <div className="box bg-primary text-white">
                    <div className="box-body">
                      <div className="mb-15 d-flex justify-content-between align-items-center">
                        <h4 className="my-0">Glucose Level(Sugar)</h4>
                        <i className="fs-18 mdi mdi-heart-outline"></i>
                      </div>
                      <h5 className="fw-400 my-0">75/118</h5>
                    </div>
                    <div className="box-body pt-0" style={{ padding: '5%' }}>
                      <div id="heartrate" style={{ height: '100%' }}>
                        <ReactApexChart
                          type="line"
                          height={200}
                          width="100%"
                          options={{
                            chart: {
                              id: 'bp-chart',  // Ensure each chart has a unique id
                              height: undefined,
                              zoom: {
                                enabled: true,  // Enable zoom for better exploration
                              },
                              toolbar: {
                                show: false,   // ✅ This removes the toolbar
                              },
                            },

                            stroke: {
                              width: 3,  // Make the line thicker for visibility
                              curve: 'smooth',  // Smooth curve for the line
                              colors: ['#ffffff']
                            },
                            grid: {
                              borderColor: '#444',  // Set grid line color for contrast
                            },
                            tooltip: {
                              theme: 'dark',  // Tooltip theme
                            },
                            xaxis: {
                              categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May'],  // Example X-axis categories
                            },
                            yaxis: {
                              show: true,
                              labels: {
                                style: {
                                  colors: '#fff',  // Set label color to white
                                },
                              },
                            },
                          }}
                          series={[{ name: 'Glucose', data: glucoseData }]}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                {/* Oxygen Card */}
                <div className="col-xl-3 col-lg-6 col-12">
                  <div className="box text-white box-typography">
                    <div className="box-body">
                      <div className="mb-15 d-flex justify-content-between align-items-center">
                        <h4 className="my-0">Oxygen</h4>
                        <i className="fs-18 mdi mdi-heart-outline"></i>
                      </div>
                      <h5 className="fw-400 my-0">75/118</h5>
                    </div>
                    <div className="box-body pt-0 " style={{ padding: '5%' }}>
                      <div id="heartrate" style={{ height: '100%' }}>
                        <ReactApexChart
                          type="line"
                          height={200}
                          width="100%"
                          options={{
                            chart: {
                              id: 'bp-chart',  // Ensure each chart has a unique id
                              height: undefined,
                              zoom: {
                                enabled: true,  // Enable zoom for better exploration
                              },
                              toolbar: {
                                show: false,   // ✅ This removes the toolbar
                              },
                            },

                            stroke: {
                              width: 3,  // Make the line thicker for visibility
                              curve: 'smooth',  // Smooth curve for the line
                              colors: ['#5156be']
                            },
                            grid: {
                              borderColor: '#444',  // Set grid line color for contrast
                            },
                            tooltip: {
                              theme: 'dark',  // Tooltip theme
                            },
                            xaxis: {
                              categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May'],  // Example X-axis categories
                            },
                            yaxis: {
                              show: true,
                              labels: {
                                style: {
                                  colors: '#black',  // Set label color to white
                                },
                              },
                            },
                          }}
                          series={[{ name: 'SpO2', data: oxygenData }]}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                {/* Upcoming Appointments Section */}
                <div className="col-xxxl-8 col-xl-7 col-12">
                  <div className="box">
                    <div className="box-header">
                      <h4 className="box-title">Medicine Schedule</h4>
                    </div>
                    <div className="box-body">
                      {/* <div className="datepaginator">
                        <ul className="pagination">
                          <li className="nav-item">
                            <a href="#" className="dp-nav dp-nav-left" title="Previous">
                              <i className="glyphicon glyphicon-chevron-left"></i>
                            </a>
                          </li>

                          {dates.map((dateItem) => (
                            <li key={dateItem.date} className="date-item">
                              <a
                                href="#"
                                className={`dp-item ${dateItem.selected ? "dp-selected" : ""} ${dateItem.off ? "dp-off" : ""}`}
                                data-moment={dateItem.date}
                                title={dateItem.title}
                                onClick={() => !dateItem.off && handleDateClick(dateItem.date)}
                              >
                                <span dangerouslySetInnerHTML={{ __html: dateItem.label }} />
                              </a>
                            </li>
                          ))}

                          <li className="nav-item">
                            <a href="#" className="dp-nav dp-nav-right" title="Next">
                              <i className="glyphicon glyphicon-chevron-right"></i>
                            </a>
                          </li>
                        </ul>
                      </div>
                      <div className="inner-user-div4">
                        {appointments.map((appointment, index) => (
                          <div key={index}>
                            <div className="d-flex align-items-center mb-10">
                              <div className="me-15">
                                <img
                                  src={appointment.avatar}
                                  className="avatar avatar-lg rounded10 bg-primary-light"
                                  alt={appointment.name}
                                />
                              </div>
                              <div className="d-flex flex-column flex-grow-1 fw-500">
                                <p className="hover-primary text-fade mb-1 fs-14">{appointment.name}</p>
                                <span className="text-dark fs-16">{appointment.appointment}</span>
                              </div>
                              <div>
                                <a href="#" className="waves-effect waves-circle btn btn-circle btn-primary-light btn-sm">
                                  <i className="fa fa-phone"></i>
                                </a>
                              </div>
                            </div>
                            <div className="d-flex justify-content-between align-items-end mb-15 py-10 bb-dashed border-bottom">
                              <div>
                                <p className="mb-0 text-muted">
                                  <i className="fa fa-clock-o me-5"></i> {appointment.time}
                                  {appointment.price && <span className="mx-20">{appointment.price}</span>}
                                </p>
                              </div>
                              <div>
                                <div className="dropdown">
                                  <a data-bs-toggle="dropdown" href="#" className="base-font mx-10">
                                    <i className="ti-more-alt text-muted"></i>
                                  </a>
                                  <div className="dropdown-menu dropdown-menu-end">
                                    <a className="dropdown-item" href="#">
                                      <i className="ti-import"></i> Import
                                    </a>
                                    <a className="dropdown-item" href="#">
                                      <i className="ti-export"></i> Export
                                    </a>
                                    <a className="dropdown-item" href="#">
                                      <i className="ti-printer"></i> Print
                                    </a>
                                    <div className="dropdown-divider"></div>
                                    <a className="dropdown-item" href="#">
                                      <i className="ti-settings"></i> Settings
                                    </a>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div> */}

                      <div className="med-row-container rounded-3">

                        {/* Left Side Info */}
                        <div className="med-info-section">
                          <div className="med-icon-box">
                            💊
                          </div>
                          <div className="med-text">
                            <div className="med-title">Dominic Foster</div>
                            <div className="med-meta">
                              <span>📅 12 Aug 2025</span>
                              <span className="text-muted">|</span>
                              <span>🕒 11:35 PM</span>
                              <span className="text-muted">|</span>
                              <span className="dose-highlight">Doses: 2 Tablets</span>
                            </div>
                          </div>
                        </div>

                        {/* Right Side Actions */}
                        <div className="med-action-section">
                          <span className="category-badge">Urology</span>

                          <div className="button-group">
                            <button className="btn btn-primary">Details</button>
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>

                {/* Notifications Section */}
                <div className="col-xxxl-4 col-xl-5 col-12">
                  <div className="box">
                    <div className="box-header">
                      <h4 className="box-title">Notifications</h4>
                    </div>
                    <div className="box-body notification-box">
                      <ul className="notification-list">
                        <li className="notification-item">
                          <span className="notify-icon info">
                            <i className="fa fa-users text-info"></i>
                          </span>
                          <p className="notify-text">Curabitur id eros quis nunc suscipit blandit.</p>
                        </li>
                        <li className="notification-item">
                          <span className="notify-icon warning">
                            <i className="fa fa-exclamation-triangle text-warning"></i>
                          </span>
                          <p className="notify-text">Duis malesuada justo eu sapien elementum, in semper diam posuere.</p>
                        </li>
                        <li className="notification-item">
                          <span className="notify-icon info">
                            <i className="fa fa-users text-info"></i>
                          </span>
                          <p className="notify-text">Curabitur id eros quis nunc suscipit blandit.</p>
                        </li>
                        <li className="notification-item">
                          <span className="notify-icon warning">
                            <i className="fa fa-exclamation-triangle text-warning"></i>
                          </span>
                          <p className="notify-text">Duis malesuada justo eu sapien elementum, in semper diam posuere.</p>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

            </div>

            {/* Right Sidebar - Appointments */}
            <div className="col-xxxl-3 col-xl-4 col-12">
              <a className="box box-body mb-5" href="#">
                <div className="d-flex align-items-center">
                  <img className="me-15 avatar avatar-lg bg-primary-light rounded-circle" src="../images/avatar/avatar-2.png" alt="" />
                  <div className="text-start">
                    <h2 className="text-primary mb-0 fs-26">Dr. Kevin Black</h2>
                    <h4>Cardiologists</h4>
                  </div>
                </div>
              </a>

              <div className="box b-0 bg-transparent no-shadow">
                <div className="box-body pb-0 px-0 d-flex align-items-center ">
                  <h4 className="mb-0 me-3">Appointment Details</h4>

                  <button className="waves-effect waves-light btn btn-primary schedule-appointment-btn" onClick={() => { setShowConfirm(true); }}>
                    <i className="mdi mdi-plus me-2" ></i> Schedule Appointment
                  </button>
                </div>
              </div>

              {/* Appointment Cards */}
              {[
                { type: 'Routine Checkup', color: 'success', name: 'Meculam Deo', time: '09:15am - 10:45am', doctor: 'Dr. Meculam', phone: '+1 142 536 7890', status: 'Bulk Billed' },
                { type: 'Emergency', color: 'danger', name: 'Maical Deo', time: '09:15am - 10:45am', doctor: 'Dr. Maical Deo', phone: '+1 421 563 7458', status: 'Bulk Billed' },
              ].map((appt, i) => (
                <div className="box" key={i}>
                  <div className="box-body">
                    <span className={`badge ${appt.type === 'Routine Checkup' ? 'badge-success' : 'badge-danger'}`}>{appt.type}</span>
                    <h4 className="mt-20 mb-10">{appt.name} - Standard Consult</h4>
                    <div className="d-flex bb-1 mb-15 pb-15">
                      <p className="mb-0 text-mute me-20">{appt.time}</p>
                      <p className="mb-0 text-mute">
                        <i className="fa fa-clock-o me-5"></i>
                        <span className="text-primary">Starts in 15 m</span>
                      </p>
                    </div>
                    <div className="d-flex align-items-center justify-content-between">
                      <div className="d-flex align-items-center">
                        <img className="me-15 avatar avatar-lg bg-primary-light rounded-circle" src={`../images/avatar/avatar-${i + 3}.png`} alt="" />
                        <div className="text-start">
                          <h4 className="text-primary mb-0">{appt.doctor}</h4>
                          <small>{appt.phone}</small>
                        </div>
                      </div>
                      <div>
                        <span className={`badge badge-xl badge-dot badge-${appt.status === 'Billed' ? 'primary' : 'dark'} me-2`}></span>
                        {appt.status}
                      </div>
                    </div>
                  </div>
                  <div className="box-footer text-end">
                    <button className="waves-effect waves-light btn-sm btn btn-secondary">
                      <i className="mdi mdi-pencil me-15"></i>Edit Consult
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      </div>



      <Dialog
        open={showModal1}
        maxWidth="md"
        fullWidth
        className="auth-modal glass-modal"
        onClose={() => setShowModal1(false)}
        BackdropProps={{
          style: { backgroundColor: "rgba(0,0,0,0.2)", backdropFilter: "blur(5px)" },
        }}
      >

        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            pt: 3,
            pb: 5,
          }}
        >
          <h3 style={{ margin: 0 }}>Initial Health Questionnaire</h3>
          <IconButton
            onClick={() => setShowModal1(false)}
            sx={{ color: "red" }} // red color
          >
            <CloseIcon sx={{ color: "gray", "&:hover": { color: "darkred" } }} />
          </IconButton>
        </DialogTitle>

        <DialogContent className="px-4 pb-3">
          <Stepper activeStep={activeStep} alternativeLabel>
            {steps.map((label) => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>

          <form className="mt-3">{stepContents[activeStep]}</form>
        </DialogContent>

        <DialogActions className="pb-3 px-4 d-flex justify-content-end">

          <button
            className="btn btn-warning"
            disabled={activeStep === 0} onClick={handleBack}
          >
            Back
          </button>

          {activeStep === steps.length - 1 ? (

            <button className="btn btn-primary" onClick={() => setShowModal1(false)}>
              Save
            </button>

          ) : (

            <button className="btn btn-primary" onClick={handleNext}>
              Next
            </button>
          )}



        </DialogActions>
      </Dialog>

      <Dialog
        open={showConfirm}
        maxWidth="sm"
        fullWidth
        className="auth-modal glass-modal"
        onClose={() => setShowConfirm(false)}
        BackdropProps={{
          style: {
            backgroundColor: "rgba(0,0,0,0.2)",
            backdropFilter: "blur(5px)",
          },
        }}
      >
        {/* HEADER */}
        <DialogTitle className="pt-30 pb-10 text-center">
          <h3 className="mb-1">Whom do you want to book an appointment </h3>
          <p className="text-muted fs-14 mb-0">
            Please select a family member
          </p>
        </DialogTitle>

        {/* CONTENT */}
        <DialogContent className="px-40 pb-20 d-flex justify-content-center">
          <RadioGroup
            row
            value={selectedPerson}
            onChange={(e) => setSelectedPerson(e.target.value)}
            className="justify-content-center mt-3"
          >
            <FormControlLabel value="father" control={<Radio />} label="Father" />
            <FormControlLabel value="mother" control={<Radio />} label="Mother" />
            <FormControlLabel value="sister" control={<Radio />} label="Sister" />
            <FormControlLabel value="spouse" control={<Radio />} label="Spouse" />
          </RadioGroup>
        </DialogContent>

        {/* FOOTER */}

        <DialogActions className="pb-3 px-4 d-flex justify-content-end gap-2">
          <button className="btn btn-warning"
            onClick={() => {
              // handle booking here
              setShowConfirm(false);
            }}>Cancel</button>
          <button className="btn btn-primary" onClick={() => { setShowConfirm(false); navigate("/appointment") }} disabled={!selectedPerson}>Schedule Appointment</button>
        </DialogActions>

      </Dialog>



    </div>
  );
};

export default Dashboard;